// extracted by mini-css-extract-plugin
export default {"div":"ProductReviewItems_div__gCbFp","article":"ProductReviewItems_article__-yH2p"};